export default function (Alpine) {
  Alpine.directive('typewriter', (el, { expression }, { evaluate, cleanup }) => {
    const raw = evaluate(expression) || {};
    const speed     = typeof raw === 'string' ? 80    : (raw.speed     ?? 80);
    const cursor    = typeof raw === 'string' ? true  : (raw.cursor    ?? true);
    const loop      = typeof raw === 'string' ? true  : (raw.loop      ?? true);
    const loopDelay = typeof raw === 'string' ? 1500  : (raw.loopDelay ?? 1500);

    // Collect texts from child spans, falling back to element text content
    const spans = [...el.querySelectorAll('span[data-tw]')];
    const texts = spans.length > 0
      ? spans.map(s => s.textContent.trim())
      : [el.textContent.trim()];

    spans.forEach(s => s.remove());

    let intervalId;
    let timeoutId;
    let index = 0;
    let started = false;

    const type = () => {
      const text = texts[index];
      let i = 0;

      intervalId = setInterval(() => {
        if (i < text.length) {
          el.textContent += text[i];
          i++;
        } else {
          clearInterval(intervalId);

          const isLast = index === texts.length - 1;

          if (loop || !isLast) {
            timeoutId = setTimeout(() => erase(), loopDelay);
          } else {
            if (cursor) delete el.dataset.typewriterCursor;
          }
        }
      }, speed);
    };

    const erase = () => {
      intervalId = setInterval(() => {
        if (el.textContent.length > 0) {
          el.textContent = el.textContent.slice(0, -1);
        } else {
          clearInterval(intervalId);
          index = loop ? (index + 1) % texts.length : index + 1;
          timeoutId = setTimeout(() => type(), speed);
        }
      }, speed / 2);
    };

    const start = () => {
      if (started) return;
      started = true;

      el.textContent = '';
      if (cursor) el.dataset.typewriterCursor = '';

      type();
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          start();
          observer.unobserve(el);
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);

    cleanup(() => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
      observer.disconnect();
    });
  });
}
